import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useTheme } from "@repo/tokens";

export const DoubtsPage2 = () => {
  const { t } = useTranslation("doubts");
  const { theme } = useTheme();

  return (
    <div style={{ padding: theme.spacing.lg, textAlign: "center" }}>
      <h1>{t("page2_title")}</h1>
      <Link
        to=".."
        style={{
          display: "inline-block",
          marginTop: theme.spacing.md,
          padding: `${theme.spacing.md}px ${theme.spacing.lg}px`,
          backgroundColor: theme.colors.primary[50],
          color: theme.colors.neutral[100],
          borderRadius: theme.radii.md,
          textDecoration: "none",
          fontWeight: theme.typography.body.medium.emphasized.fontWeight,
        }}
      >
        {t("go_back")}
      </Link>
    </div>
  );
};
